import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'lib/i18n';
import { Form } from 'reactifi-local';

export default class VenueDetailsComponent extends React.Component {
  static propTypes = {
    actions: PropTypes.shape({
      clearMessages: PropTypes.func.isRequired,
      toggleEditVenue: PropTypes.func.isRequired,
    }).isRequired,
    event: PropTypes.object,
    required: PropTypes.bool,
    selectedVenue: PropTypes.shape({
      location_formatted_address: PropTypes.string,
      location_room: PropTypes.string,
      title: PropTypes.string,
    }),
  };

  openVenueForm = () => {
    const { actions } = this.props;
    actions.clearMessages();
    actions.toggleEditVenue(true);
  };

  render() {
    const { event, required, selectedVenue } = this.props;

    const venueDisplay = selectedVenue && (
      <>
        <p className="m-b-0">
          <strong>{selectedVenue.title}</strong>
        </p>
        <p>
          {selectedVenue.location_formatted_address} {selectedVenue.location_room}
        </p>
      </>
    );

    return (
      <div className="form-well p-20">
        <h4>
          {i18n.t('Event Venue')}
          {required && (
            <span>
              <span aria-hidden="true">*</span>
              <span className="sr-only"> {i18n.t('required')}</span>
            </span>
          )}
        </h4>
        <p>{i18n.t('Please tell us a little more about where the event will take place.')}</p>
        {venueDisplay}
        <Form cancelButton={false} data={event} saveButton={false}>
          <a className="btn btn-secondary m-0" onClick={this.openVenueForm}>
            {!selectedVenue ? i18n.t('Add Venue') : i18n.t('Edit Venue')}
          </a>
        </Form>
      </div>
    );
  }
}
